<template>
    <FooterBody
        v-if="isFooterView && footer.uuid"
        id="view-footer"
        :footer="footer"
        @updateIframeHeight="updateHeight"
    />
    <TermsBody
        v-if="isTermsView && footer.uuid"
        id="view-terms"
        :footer="footer"
        @updateIframeHeight="updateHeight"
    />
    <PolicyBody
        v-if="isPolicyView && footer.uuid"
        id="view-policy"
        :footer="footer"
        @updateIframeHeight="updateHeight"
    />
    <AboutBody
        v-if="isAboutView && footer.uuid"
        id="view-about"
        :footer="footer"
        @updateIframeHeight="updateHeight"
    />
    <NdaBody
        v-if="isNdaView && footer.uuid && footer.nda.id"
        id="view-nda"
        :footer="footer"
        @updateIframeHeight="updateHeight"
    />
</template>

<script>
import FooterBody from "@/views/tools/legal/footers/FooterBody.vue";
import TermsBody from "@/views/tools/legal/terms/TermsBody.vue";
import PolicyBody from "@/views/tools/legal/policies/PolicyBody.vue";
import AboutBody from "@/views/tools/legal/about/AboutBody.vue";
import NdaBody from "@/views/tools/legal/ndas/NdaBody.vue";
import { footersService } from "@/apps/legal/services/footers.service";
import { setFontFamily, updateIframeHeight } from "@/shared/utils";
import { prepareFooter } from "@/shared/projects/prepareData";
import { PREVIEW_ROUTE_NAMES } from "@/views/preview/preview.routes";
import { projectsService } from "@/shared/projects/projects.service";

export default {
    name: "LegalPreviewPage",
    components: {
        FooterBody,
        TermsBody,
        PolicyBody,
        AboutBody,
        NdaBody,
    },
    data() {
        return {
            footer: {},
            windowWidth: window.width,
            currentFont: "Inter",
            waiting: false,
        };
    },
    computed: {
        isFooterView() {
            return this.$route.name === PREVIEW_ROUTE_NAMES.legalFooter;
        },
        isTermsView() {
            return this.$route.name === PREVIEW_ROUTE_NAMES.legalTerms;
        },
        isPolicyView() {
            return this.$route.name === PREVIEW_ROUTE_NAMES.legalPrivacy;
        },
        isAboutView() {
            return this.$route.name === PREVIEW_ROUTE_NAMES.legalAbout;
        },
        isNdaView() {
            return this.$route.name === PREVIEW_ROUTE_NAMES.legalNda;
        },
    },
    async mounted() {
        if (window.location === window.parent.location) {
            try {
                const { projectUuid, legalUuid } = this.$route.params;
                if (this.isFooterView || this.isNdaView) {
                    this.footer = await this.loadFooter(projectUuid);
                } else {
                    this.$footer = await this.loadFooterByLegal(legalUuid);
                }
                this.adjustIframe();
            } catch {
                this.$router.push({ name: PREVIEW_ROUTE_NAMES.notFound });
            }
        } else {
            window.addEventListener("message", this.refreshIframe);
        }
        window.addEventListener("resize", this.resizeIframe);
    },
    beforeUnmount() {
        window.removeEventListener("message", this.refreshIframe);
        window.removeEventListener("resize", this.resizeIframe);
    },
    methods: {
        async loadFooter(uuid) {
            this.waiting = true;
            const footer = await projectsService.getOne({ tool: "legal", uuid });
            this.waiting = false;
            return prepareFooter(footer);
        },
        async loadFooterByLegal(uuid) {
            this.waiting = true;
            const footer = await footersService.getOneByLegalUuid(uuid);
            this.waiting = false;
            return prepareFooter(footer);
        },
        async refreshIframe(e) {
            //refreshData
            if (e.data.footerData) {
                this.footer = e.data.footerData;
                this.adjustIframe();
            }
            //refreshView
            if (e.data.footerView) {
                const view = e.data.footerView;
                if (view === "footer") {
                    await this.$router.push({
                        name: PREVIEW_ROUTE_NAMES.legalFooter,
                        params: {
                            projectUuid: this.footer.uuid,
                        },
                    });
                }
                if (view === "terms") {
                    await this.$router.push({
                        name: PREVIEW_ROUTE_NAMES.legalTerms,
                        params: {
                            legalUuid: this.footer.legal.uuid,
                        },
                    });
                }
                if (view === "policy") {
                    await this.$router.push({
                        name: PREVIEW_ROUTE_NAMES.legalPrivacy,
                        params: {
                            legalUuid: this.footer.legal.uuid,
                        },
                    });
                }
                if (view === "about") {
                    await this.$router.push({
                        name: PREVIEW_ROUTE_NAMES.legalAbout,
                        params: {
                            legalUuid: this.footer.legal.uuid,
                        },
                    });
                }
                setTimeout(() => {
                    this.updateHeight();
                }, 100);
            }
        },
        async adjustIframe() {
            if (!this.footer.id) return;
            this.currentFont = setFontFamily(this.footer.fontFamily, this.currentFont);
            await this.$nextTick();
            this.updateHeight();
        },
        updateHeight() {
            updateIframeHeight("footer", this.footer.uuid);
        },
        resizeIframe() {
            if (window.innerWidth !== this.windowWidth) {
                this.adjustIframe();
                this.windowWidth = window.innerWidth;
            }
        },
    },
};
</script>
